// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"35419190","315":"44ab2344","511":"f4cf16b3","609":"392b4c1e","773":"a63d18b1","849":"5a980fb5"}[chunkId] + ".chunk.js";
};